export default function PHP_trim() {
  return (
    <div>
      <h1>PHP_trim</h1>
    </div>
  );
}
